import { Tabs, TabsContent, TabsList, TabsTrigger } from "@patient-watch/ui/tabs";
import { requireTab } from "@/features/navigation/requireTab";
import { createFileRoute } from "@tanstack/react-router";
import Title from "../../../components/common/Title";
import { useHelpCopy } from "@/features/i18n/helpCopy";
import { HelpTopicCard } from "@/features/help/components/HelpTopicCard";
import { HelpNewDiaryPreview } from "@/features/help/previews/HelpNewDiaryPreview";
import { HelpTemplateWorkflowPreview } from "@/features/help/previews/HelpTemplateWorkflowPreview";
import { HelpPatientsTabsPreview } from "@/features/help/previews/HelpPatientsTabsPreview";
import { HelpDiaryStatusLegendPreview } from "@/features/help/previews/HelpDiaryStatusLegendPreview";
import { HelpRemindPatientPreview } from "@/features/help/previews/HelpRemindPatientPreview";
import { HelpClinicianActionsPreview } from "@/features/help/previews/HelpClinicianActionsPreview";
import { HelpMoreActionsPreview } from "@/features/help/previews/HelpMoreActionsPreview";

const ClinicianHelpPage = () => {
    const copy = useHelpCopy();

    return (
        <section className="lg-width">
            <Title words={copy.clinicianTitle} />
            <div className="space-y-8">
                <Tabs defaultValue="diaries" className="w-full">
                    <TabsList className="grid grid-cols-4 w-full">
                        <TabsTrigger value="diaries">{copy.tabTemplates}</TabsTrigger>
                        <TabsTrigger value="status">{copy.tabDiaryStatus}</TabsTrigger>
                        <TabsTrigger value="reminders">{copy.tabReminders}</TabsTrigger>
                        <TabsTrigger value="actions">{copy.tabActions}</TabsTrigger>
                    </TabsList>

                    <TabsContent value="diaries" className="space-y-4 mt-4">
                        <HelpTopicCard
                            title={copy.clinicianDiaries.title}
                            description={copy.clinicianDiaries.description}
                            steps={copy.clinicianDiaries.steps}
                            commonIssues={copy.clinicianDiaries.commonIssues}
                            preview={
                                <div className="space-y-6">
                                    <HelpTemplateWorkflowPreview />
                                    <HelpNewDiaryPreview />
                                </div>
                            }
                        />
                    </TabsContent>

                    <TabsContent value="status" className="space-y-4 mt-4">
                        <HelpTopicCard
                            title={copy.clinicianStatus.title}
                            description={copy.clinicianStatus.description}
                            steps={copy.clinicianStatus.steps}
                            commonIssues={copy.clinicianStatus.commonIssues}
                            preview={
                                <div className="space-y-6">
                                    <HelpPatientsTabsPreview />
                                    <HelpDiaryStatusLegendPreview />
                                </div>
                            }
                        />
                    </TabsContent>

                    <TabsContent value="reminders" className="space-y-4 mt-4">
                        <HelpTopicCard
                            title={copy.clinicianReminders.title}
                            description={copy.clinicianReminders.description}
                            steps={copy.clinicianReminders.steps}
                            commonIssues={copy.clinicianReminders.commonIssues}
                            preview={
                                <div className="space-y-6">
                                    <HelpMoreActionsPreview highlight="messageHistory" />
                                    <HelpRemindPatientPreview />
                                </div>
                            }
                        />
                    </TabsContent>

                    <TabsContent value="actions" className="space-y-4 mt-4">
                        <HelpTopicCard
                            title={copy.clinicianActions.title}
                            description={copy.clinicianActions.description}
                            steps={copy.clinicianActions.steps}
                            commonIssues={copy.clinicianActions.commonIssues}
                            preview={
                                <div className="space-y-6">
                                    <HelpMoreActionsPreview highlight="printDiary" />
                                    <HelpClinicianActionsPreview />
                                </div>
                            }
                        />
                    </TabsContent>
                </Tabs>
            </div>
        </section>
    );
};

export const Route = createFileRoute("/_app/help/clinician")({
    beforeLoad: ({ context }) => requireTab(context, "help"),
    component: ClinicianHelpPage,
});
